<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-7xl mx-auto space-y-8">
      
      <!-- HEADER -->
      <div class="sci-page-header pb-4">
        <h1 class="sci-page-title-only">Gerador de Relatório Genérico</h1>
        <p class="text-sm text-slate-500 font-medium mt-1">Gere relatórios customizados por prefeitura e veículo</p>
      </div>

      <!-- CONFIGURAÇÕES DO RELATÓRIO -->
      <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
          <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
              <v-icon color="orange" small>mdi-file-chart-outline</v-icon>
              <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">
                  PARÂMETROS DO RELATÓRIO
              </h2>
          </div>
          <div class="p-8">
              <v-row dense>
                <v-col cols="12">
                   <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Prefeitura</label>
                  <v-autocomplete
                    v-model="filter.prefecture_id"
                    :items="prefectures"
                    item-text="prefecture_social_name"
                    item-value="prefecture_id"
                    outlined
                    dense
                    hide-details="auto"
                    class="bg-slate-50"
                    placeholder="Selecione a prefeitura"
                    @change="[getSecretariats(),getVehiclesByPrefecture()]"
                  />
                </v-col>
                
                <v-col cols="12" sm="12" md="3">
                  <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Data Inicial</label>
                  <Date
                    @dateValue="[(filter.startDate = $event)]"
                    label="Data Inicial"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Data Final</label>
                  <Date 
                    @dateValue="[(filter.endDate = $event)]" 
                    label="Data Final" 
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6">
                   <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Veículo</label>
                  <v-autocomplete
                    v-model="filter.vehicle_id"
                    :items="vehicles"
                    item-text="model_desc"
                    item-value="vehicle_id"
                    outlined
                    dense
                    clearable
                    hide-details="auto"
                    class="bg-slate-50"
                    placeholder="Todos os veículos (opcional)"
                  >
                    <template slot="selection" slot-scope="{ item }">
                      {{ item.brand_desc }} - {{ item.model_desc }} - {{ item.vehicle_board }}
                    </template>
                    <template slot="item" slot-scope="{ item }">
                      {{ item.brand_desc }} - {{ item.model_desc }} - {{ item.vehicle_board }}
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>

              <div class="flex justify-end mt-8">
                  <button 
                    @click="filter.startDate && filter.endDate && filter.prefecture_id ? navigateToReport() : null"
                    :disabled="!(filter.startDate && filter.endDate && filter.prefecture_id)"
                    class="bg-orange-500 hover:bg-orange-600 text-white rounded-lg shadow-md shadow-orange-500/20 px-8 h-12 transition-all transform hover:-translate-y-0.5 flex items-center justify-center gap-2 text-[11px] font-black uppercase tracking-widest disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                      <v-icon color="white" small class="mr-1">mdi-file-download-outline</v-icon>
                      GERAR RELATÓRIO
                  </button>
              </div>
          </div>
      </section>

      <v-snackbar
        multi-line
        :color="snack.color"
        v-model="snack.show"
        transition="fade-transition"
        top
        right
      >
        {{ snack.message }}
        <template v-slot:action="{ attrs }">
          <v-btn dark text v-bind="attrs" @click="snack.show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import Date from "@/components/InputDate.vue";
import Helpers from "@/mixins/helpers";
export default {
  components: { Date },
  mixins: [Helpers],
  data: () => ({
    prefectures: [],
    secretariats: [],
    vehicles: [],
    singleVehicle: {},
    dataVehicle: [],
    dataSupplies: [],
    selectedSupplies: [],
    headers: [
      { text: "Data/Hora", value: "datehour", sortable: false },
      { text: "Item", value: "item_description_desc", sortable: false },
      {
        text: "Litros Abastecidos",
        value: "supply_liters_stocked",
        sortable: false,
      },
      {
        text: "Valor",
        value: "supply_price_day",
        sortable: false,
      },
      { text: "Total", value: "supply_value", sortable: false },
      { text: "Senha", value: "supply_code", sortable: false },
      { text: "Status", value: "supply_status", sortable: false },
      { text: "Corrigido", value: "supply_ajusted", sortable: false },
      { text: "Faturado", value: "supply_billed", sortable: false },
    ],
    loader: false,
    resultAverage: null,
    filter: {
      vehicle_id: null,
      prefecture_id: null,
      sec_id: null,
      startDate: null,
      endDate: null,
    },
    snack: {
      show: false,
      message: "",
      color: "",
    },
  }),
  created() {
    this.Helpers;
    this.loader = true;
    this.$store.dispatch("setLoader", this.loader);
    this.$http.get(`/prefectures`).then((r) => {
      this.prefectures = r.data;

      // Auto-seleciona se houver apenas uma prefeitura (comum para administradores restritos)
      if (this.prefectures.length === 1 && !this.filter.prefecture_id) {
        this.filter.prefecture_id = this.prefectures[0].prefecture_id;
        this.getSecretariats();
        this.getVehiclesByPrefecture();
      }

      this.loader = false;
      this.$store.dispatch("setLoader", this.loader);
    });
  },
  methods: {
    getSecretariats() {
      this.filter.vehicle_id = null;
      this.vehicles = [];
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/distribution/secretariats/${this.filter.prefecture_id}`)
        .then((r) => {
          this.secretariats = r.data;
          this.snack.color = "success";
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    getVehicles() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/distribution/vehicles/${this.filter.sec_id}`)
        .then((v) => {
          this.vehicles = v.data;
          this.loader = false;
          this.snack.color = "success";
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    getVehiclesByPrefecture() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/distribution/vehicles/prefecture/${this.filter.prefecture_id}`)
        .then((v) => {
          this.vehicles = v.data;
          this.loader = false;
          this.snack.color = "success";
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    getSingleVehicle() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/distribution/vehicle/${this.filter.vehicle_id}`)
        .then((v) => {
          this.singleVehicle = v.data[0];
          this.loader = false;
          this.snack.color = "success";
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    getVehicleData() {
      this.dataSupplies = [];
      this.dataVehicle = [];
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .post(`/distribution/vehicle/data`, this.filter)
        .then((v) => {
          this.dataSupplies = v.data[0].Supplies;
          this.dataVehicle = v.data[0];
          this.resultAverage =
            v.data[0].Average < v.data[0].vehicle_average_consumption_minimum
              ? "ABAIXO DA MÉDIA"
              : v.data[0].Average >=
                  v.data[0].vehicle_average_consumption_minimum &&
                v.data[0].Average <=
                  v.data[0].vehicle_average_consumption_maximum
              ? "NA MÉDIA"
              : "ACIMA DA MÉDIA";

          this.loader = false;
          this.snack.color = "success";
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    navigateToReport() {
      const url = `${window.origin}/#/report/master/generic/${this.filter.startDate}/${this.filter.endDate}/${this.filter.prefecture_id}/${this.filter.vehicle_id || 'null'}`;
      window.open(url, '_blank');
    },
    updateSupplies() {
      let c = confirm("Deseja desbloquear os abastecimentos selecionados?");
      if (c) {
        this.$http
          .put("/distribution/vehicle/data", {
            supplies: this.selectedSupplies,
            filter: this.filter,
          })
          .then((r) => {
            this.loader = false;
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.getVehicleData();
            this.snack.type = "error";
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.loader = false;
            this.snack.show = true;
            this.snack.message = e;
            this.snack.type = "error";
            this.$store.dispatch("setLoader", this.loader);
          });
      }
    },
  },
};
</script>

<style>
</style>